
export default class WizardSteps {

    static BASKET_OVERVIEW = 0;
   // static SHIPPING_INFO = 1;
   // static PAYMENT_INFO = 2;
    static CONTACT_INFO = 3;
    static ORDER_CONFIRM = 4;
    static ORDER_PROCESSING = 5;
    static ORDER_SUCCESSFUL = 6;
    static ORDER_FAILED = 7;
    
    static SIMPLE_CONTACT_INFO = 30;
}